module.exports = __webpack_public_path__ + "img/test-conveyor.c220ad5d.svg";